const wrapper = "_35sw1g5hkap";

export { wrapper };
import "./organism.input-container.style.linaria.module.css";
//# sourceMappingURL=organism.input-container.style.js.map
